module.exports = __webpack_public_path__ + "static/media/loanStatusWhite.7e65b738.svg";